export class ValuesModel {
  value: number;
  label: string;

  constructor(obj?: Partial<ValuesModel>) {
    this.value = obj?.value ?? 0;
    this.label = obj?.label ?? '';
  }
}
